<template>
  <div>
    <div class="plan-tab">
      <template v-for="(planTab, indexTab) in dataPlan.plans">
        <div
          v-if="planTab.show && planTab.groups.length"
          class="plan-tab--item"
          :class="{
            'tab-plan-starter': planTab.name == 'starter',
            'tab-plan-professional': planTab.name == 'professional',
            'tab-plan-advanced': planTab.name == 'advanced', 
            'tab-plan--active': mobileTab[planTab.name], 
          }"
          @click="switchPlanTabMobile(planTab.name)"
          :key="indexTab"
        >
          <h2>{{ $t(planTab.title) }}</h2>
        </div>
      </template>
    </div>
    <div class="gp_plans-mobie gp_plans-mobie--top">
      <template v-for="(planTabInfo, indexTab) in dataPlan.plans">
        <div
          v-if="planTabInfo.show && planTabInfo.groups.length"
          class="plan-tab--info"
          :class="{
              'info-plan--active': mobileTab[planTabInfo.name], 
            }"
          :key="indexTab"
        >
          <div class="plan-item-discount" v-if="isShowAdvandDiscount && planTabInfo.name === 'advanced'">
            <div class="plan-item-discount--advanced">
              <div class="discount-advanced--first">
                {{ $t("dataPlan.advanced.discount.first") }}
              </div>
              <div class="discount-advanced--last" v-html="$t('dataPlan.advanced.discount.last')"></div>
            </div>
          </div>
          <div class="d-flex justify-content-center bg-primary-300 border-radius plan-discount__box plan-item-discount--professional" v-if="isShowBusinessDiscount && planTabInfo.name === 'professional'" >
            <div class="d-flex align-items-center px-3 py-1 plan-discount__wrapper">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.36634 15.0641C9.28824 15.1422 9.1616 15.1422 9.0835 15.0641L5.92314 11.9037C5.72788 11.7085 5.41129 11.7085 5.21603 11.9037L4.35355 12.7662C4.15829 12.9615 4.15829 13.278 4.35355 13.4733L8.51781 17.6376C8.90834 18.0281 9.5415 18.0281 9.93203 17.6376L19.6464 7.92314C19.8417 7.72788 19.8417 7.41129 19.6464 7.21603L18.784 6.35355C18.5887 6.15829 18.2721 6.15829 18.0769 6.35355L9.36634 15.0641Z" fill="#00C753" />
              </svg>

              <span class="txt-light-grey-600 heading-16-medium mr-4px ml-1">{{ $t("pricing.promotionCodeApplied") }}</span>
              
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.50799 14L6.77087 16.3721L9.01599 17.6279L6.77087 18.8837L5.50799 21.1163L4.24512 18.8837L2 17.6279L4.24512 16.3721L5.50799 14Z" fill="#FFBB1C" />
                <path d="M15.1563 3L17.8224 7.60465L22.4529 10.1163L17.8224 12.6279L15.1563 17.2326L12.6305 12.6279L8 10.1163L12.6305 7.60465L15.1563 3Z" fill="#FFBB1C" />
              </svg>
            </div>
          </div>
          <div class="info-plan-box" :class="{
            'header-plan-starter':  planTabInfo.name == 'starter',
            'header-plan-professional':  planTabInfo.name == 'professional',
            'header-plan-advanced':  planTabInfo.name == 'advanced', 
            'plan-item-discount--radius': (isShowAdvandDiscount && planTabInfo.name === 'advanced') || (isShowBusinessDiscount && planTabInfo.name === 'professional'), 
          }">
            <h2>{{ $t(planTabInfo.title) }}</h2>
            <div class="info-plan--price" :key="planTabInfo.price_discount">
              <span>${{ getPriceForPlan(planTabInfo.name) }}</span> 
              <template v-if="isShowAdvandDiscount && planTabInfo.name === 'advanced'">
                <span class="info-plan--price-old">${{planTabInfo.price}}</span>
              </template>
              <template v-if="isShowBusinessDiscount && planTabInfo.name === 'professional'">
                <span class="info-plan--price-old">${{planTabInfo.price}}</span>
              </template>
              /{{ $t("dataPlan.plan.month") }}
            </div>
            <button
              class="gt_btn"
              :disabled="checkPlanStatus(planTabInfo.name).disable"
              :class="{
                'professional': planTabInfo.name === 'professional' && planTabInfo.name !== currentPlan,
              }"
              @click="changePlan(planTabInfo.name)"
            >
              <div v-html="checkPlanStatus(planTabInfo.name).label" />
            </button>
          </div>
        </div>
      </template>
    </div>
    <div class="gp_plans-view-more">
      <div v-if="dataPlan.plans[0]" class="plan-item">
        <div class="plan-item--inner">
          <div class="plan-item-header">
            <h2></h2>
          </div>
          <template v-for="(group, groupIndex) in dataPlan.plans[0].groups">
            <div class="plan-group" :key="groupIndex">
              <div
                v-if="group.title"
                class="plan-group--title"
                @click="changeCollapseStatus(group.keyword)"
                :class="[
                  { no_option: !group.options.length },
                  `plan-group--${group.keyword}`,
                ]"
              >
                {{ $t(group.title) }}
                <div class="tooltip" v-if="group.tooltip">
                  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.62533 4.66659C8.28015 4.66659 8.00033 4.94641 8.00033 5.29159C8.00033 5.63676 8.28015 5.91659 8.62533 5.91659C8.9705 5.91659 9.25033 5.63676 9.25033 5.29159C9.25033 4.94641 8.9705 4.66659 8.62533 4.66659Z" fill="#1E232F"/>
                    <path d="M7.58361 7.16659C7.58361 6.93647 7.77016 6.74992 8.00028 6.74992H8.41694C8.87718 6.74992 9.25028 7.12301 9.25028 7.58325V9.66659C9.25028 9.89669 9.43681 10.0832 9.66691 10.0833H10.0836C10.3137 10.0833 10.5003 10.2698 10.5003 10.4999C10.5003 10.73 10.3137 10.9166 10.0836 10.9166H9.66694C8.97659 10.9166 8.41694 10.3569 8.41694 9.66659V7.58325H8.00028C7.77016 7.58325 7.58361 7.3967 7.58361 7.16659Z" fill="#1E232F"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.11961 3.28587C6.72311 0.682378 10.9442 0.682378 13.5477 3.28587C16.1512 5.88937 16.1512 10.1105 13.5477 12.714C10.9442 15.3175 6.72311 15.3175 4.11961 12.714C1.51612 10.1105 1.51612 5.88937 4.11961 3.28587ZM4.70887 3.87513C6.98693 1.59707 10.6804 1.59707 12.9584 3.87513C15.2365 6.15319 15.2365 9.84665 12.9584 12.1247C10.6804 14.4028 6.98693 14.4028 4.70887 12.1247C2.43081 9.84665 2.43081 6.15319 4.70887 3.87513Z" fill="#1E232F"/>
                  </svg>
                  <div class="tooltip-txt">
                    {{$t(group.tooltip)}}
                  </div>
                </div>
              </div>
              <div
                v-if="group.options && group.options.length"
                class="plan-group--options"
                :class="`plan-group--${group.keyword} plan-group--${groupIndex} `"
              >
                <div
                  class="plan-group--option"
                  v-for="(option, index) in group.options"
                  :key="index"
                >
                  <div class="plan-group--option-box">
                    <div
                      :class="{ 'no-tootip': !option.tooltip }"
                      class="plan-group--option-txt"
                    >
                      {{ $t(option.title) }}
                      <!-- <div v-if="option.tag" class="tag">{{option.tag}}</div> -->
                    </div>
                    <span class="plan-height-option">
                      <template v-for="(plan2, index2) in dataPlan.plans">
                        <div v-if="plan2.show && plan2.groups.length && mobileTab[plan2.name]" :key="index2">
                          <template v-for="(group2, groupIndex2) in plan2.groups">
                            <template
                              v-if="group2.options && group2.options.length && groupIndex == groupIndex2"
                            >
                              <template v-for="(option2, index2) in group2.options">
                                <template
                                  v-if="index == index2"
                                >
                                  <template v-if="option2.desc"><span  v-html="$t(option2.desc)" :key="index2"></span></template>
                                  <template v-else>
                                    <svg :key="index2" width="25" v-if="option2.status" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12.1301 15.593C11.9039 15.593 11.7029 15.4925 11.5773 15.3418L7.78332 11.2211C7.50693 10.9196 7.53208 10.4422 7.83357 10.1659C8.13506 9.88947 8.61247 9.91462 8.88886 10.2161L12.1552 13.7588L21.2004 4.73871C21.5019 4.43722 21.9793 4.43722 22.2557 4.73871C22.5321 5.04019 22.5572 5.51761 22.2557 5.79399L12.6577 15.3669C12.5321 15.5176 12.3311 15.593 12.1301 15.593Z" fill="#456BF2"/>
                                      <path d="M12.8335 22C7.33097 22 2.8335 17.5025 2.8335 12C2.8335 6.49752 7.33097 2 12.8335 2C13.2607 2 13.5873 2.32664 13.5873 2.75375C13.5873 3.18085 13.2606 3.50749 12.8335 3.50749C8.16013 3.50749 4.34104 7.32658 4.34104 12C4.34104 16.6734 8.16013 20.4925 12.8335 20.4925C17.5069 20.4925 21.326 16.6734 21.326 12C21.326 11.5728 21.6526 11.2462 22.0798 11.2462C22.5069 11.2462 22.8335 11.5729 22.8335 12C22.8335 17.5025 18.336 22 12.8335 22Z" fill="#456BF2"/>
                                    </svg>
                                    <svg :key="index2" v-else width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="4.8335" y="11" width="16" height="2.5" rx="0.5" fill="#A2A5A9"/>
                                    </svg>
                                  </template>
                                </template>
                              </template>
                            </template>
                          </template>
                        </div>
                      </template>
                    </span>
                  </div>
                  <!-- <div v-if="option.tooltip" class="tooltip">
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.62533 4.66659C8.28015 4.66659 8.00033 4.94641 8.00033 5.29159C8.00033 5.63676 8.28015 5.91659 8.62533 5.91659C8.9705 5.91659 9.25033 5.63676 9.25033 5.29159C9.25033 4.94641 8.9705 4.66659 8.62533 4.66659Z" fill="#1E232F"/>
                      <path d="M7.58361 7.16659C7.58361 6.93647 7.77016 6.74992 8.00028 6.74992H8.41694C8.87718 6.74992 9.25028 7.12301 9.25028 7.58325V9.66659C9.25028 9.89669 9.43681 10.0832 9.66691 10.0833H10.0836C10.3137 10.0833 10.5003 10.2698 10.5003 10.4999C10.5003 10.73 10.3137 10.9166 10.0836 10.9166H9.66694C8.97659 10.9166 8.41694 10.3569 8.41694 9.66659V7.58325H8.00028C7.77016 7.58325 7.58361 7.3967 7.58361 7.16659Z" fill="#1E232F"/>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.11961 3.28587C6.72311 0.682378 10.9442 0.682378 13.5477 3.28587C16.1512 5.88937 16.1512 10.1105 13.5477 12.714C10.9442 15.3175 6.72311 15.3175 4.11961 12.714C1.51612 10.1105 1.51612 5.88937 4.11961 3.28587ZM4.70887 3.87513C6.98693 1.59707 10.6804 1.59707 12.9584 3.87513C15.2365 6.15319 15.2365 9.84665 12.9584 12.1247C10.6804 14.4028 6.98693 14.4028 4.70887 12.1247C2.43081 9.84665 2.43081 6.15319 4.70887 3.87513Z" fill="#1E232F"/>
                    </svg>
                    <div class="tooltip-txt">
                      {{ option.tooltip }} 
                    </div>
                  </div> -->
                </div>
                <div
                  class="plan-group--option last-action"
                  style="justify-content: center"
                  v-if="groupIndex === dataPlan.plans[0].groups.length - 1">
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template v-for="(plan, index) in dataPlan.plans">
        <div
          v-if="plan.show && plan.groups.length"
          class="plan-item"
          :class="{ 'plan-highlight': plan.name === planHighLight, 'plan-item--mobie-tab__hide': !mobileTab[plan.name] }"
          :key="index"
        >
          <div class="plan-item--inner">
            <div class="plan-item-discount" v-if="isShowBusinessDiscount && plan.name === 'professional'">
              <div class="plan-item-discount--professional">
                <div class="d-flex align-items-center plan-discount__wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.36634 15.0641C9.28824 15.1422 9.1616 15.1422 9.0835 15.0641L5.92314 11.9037C5.72788 11.7085 5.41129 11.7085 5.21603 11.9037L4.35355 12.7662C4.15829 12.9615 4.15829 13.278 4.35355 13.4733L8.51781 17.6376C8.90834 18.0281 9.5415 18.0281 9.93203 17.6376L19.6464 7.92314C19.8417 7.72788 19.8417 7.41129 19.6464 7.21603L18.784 6.35355C18.5887 6.15829 18.2721 6.15829 18.0769 6.35355L9.36634 15.0641Z" fill="#00C753" />
                  </svg>

                  <span class="txt-light-grey-600 heading-16-medium mr-4px ml-1">{{ $t("pricing.promotionCodeApplied") }}</span>
                  
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.50799 14L6.77087 16.3721L9.01599 17.6279L6.77087 18.8837L5.50799 21.1163L4.24512 18.8837L2 17.6279L4.24512 16.3721L5.50799 14Z" fill="#FFBB1C" />
                    <path d="M15.1563 3L17.8224 7.60465L22.4529 10.1163L17.8224 12.6279L15.1563 17.2326L12.6305 12.6279L8 10.1163L12.6305 7.60465L15.1563 3Z" fill="#FFBB1C" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="plan-item-discount" v-if="isShowAdvandDiscount && plan.name === 'advanced'">
              <div class="plan-item-discount--advanced">
                <div class="discount-advanced--first">
                  {{ $t("dataPlan.advanced.discount.first") }}
                </div>
                <div class="discount-advanced--last" v-html="$t('dataPlan.advanced.discount.last')"></div>
              </div>
            </div>
            <div class="plan-item-header" :class="'header-plan-' + plan.name">
              <h2>{{ $t(plan.title) }}</h2>
              <div class="plan-item--price" :key="plan.price_discount">
                <span>${{ getPriceForPlan(plan.name) }}</span> 
                <template v-if="isShowAdvandDiscount && plan.name === 'advanced'">
                  <span class="plan-item--price-old">${{plan.price}}</span>
                </template>/{{ $t("dataPlan.plan.month") }}
              </div>
              <button
                class="gt_btn"
                :disabled="checkPlanStatus(plan.name).disable"
                :class="{
                  'professional': plan.name === 'professional' && plan.name !== currentPlan,
                }"
                @click="changePlan(plan.name)"
              >
                <div v-html="checkPlanStatus(plan.name).label" />
              </button>
            </div>
            <template v-for="(group, groupIndex) in plan.groups">
              <div class="plan-group" :key="groupIndex">
                <div
                  v-if="group.title"
                  @click="changeCollapseStatus(group.keyword)"
                  class="plan-group--title plan-group--collapse"
                  :class="[
                    { no_option: !group.options.length },
                    `plan-group--${group.keyword}`,
                  ]"
                >
                  <svg v-if="group.collapse"  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1631 13.087L16.8373 14.4128L10.0002 7.57572L3.16309 14.4128L1.83726 13.087L10.0002 4.92407L18.1631 13.087Z" fill="#40444F"/>
                  </svg>
                </div>
                <div
                  v-if="group.options && group.options.length"
                  class="plan-group--options"
                  :class="`plan-group--${group.keyword} plan-group--${index} `"
                >
                  <div class="">
                    <div
                      class="plan-group--option"
                      style="justify-content: center"
                      v-for="(option, index) in group.options"
                      :key="index"
                    >
                      <template v-if="option.desc">
                        <span v-html="$t(option.desc)" :key="index"></span>
                      </template>
                      <template v-else>
                        <div class="svg">
                          <svg width="25" v-if="option.status" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.1301 15.593C11.9039 15.593 11.7029 15.4925 11.5773 15.3418L7.78332 11.2211C7.50693 10.9196 7.53208 10.4422 7.83357 10.1659C8.13506 9.88947 8.61247 9.91462 8.88886 10.2161L12.1552 13.7588L21.2004 4.73871C21.5019 4.43722 21.9793 4.43722 22.2557 4.73871C22.5321 5.04019 22.5572 5.51761 22.2557 5.79399L12.6577 15.3669C12.5321 15.5176 12.3311 15.593 12.1301 15.593Z" fill="#456BF2"/>
                            <path d="M12.8335 22C7.33097 22 2.8335 17.5025 2.8335 12C2.8335 6.49752 7.33097 2 12.8335 2C13.2607 2 13.5873 2.32664 13.5873 2.75375C13.5873 3.18085 13.2606 3.50749 12.8335 3.50749C8.16013 3.50749 4.34104 7.32658 4.34104 12C4.34104 16.6734 8.16013 20.4925 12.8335 20.4925C17.5069 20.4925 21.326 16.6734 21.326 12C21.326 11.5728 21.6526 11.2462 22.0798 11.2462C22.5069 11.2462 22.8335 11.5729 22.8335 12C22.8335 17.5025 18.336 22 12.8335 22Z" fill="#456BF2"/>
                          </svg>
                          <svg v-else width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="4.8335" y="11" width="16" height="2.5" rx="0.5" fill="#A2A5A9"/>
                          </svg>
                        </div>
                      </template>
                      <div v-if="option.tooltip" class="tooltip">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M7.79134 4.66683C7.44616 4.66683 7.16634 4.94665 7.16634 5.29183C7.16634 5.63701 7.44616 5.91683 7.79134 5.91683C8.13652 5.91683 8.41634 5.63701 8.41634 5.29183C8.41634 4.94665 8.13652 4.66683 7.79134 4.66683Z" fill="#1E232F"/>
                          <path d="M6.74962 7.16683C6.74962 6.93671 6.93617 6.75016 7.16629 6.75016H7.58296C8.04319 6.75016 8.41629 7.12326 8.41629 7.5835V9.66683C8.41629 9.89694 8.60282 10.0835 8.83293 10.0835H9.24962C9.47974 10.0835 9.66629 10.27 9.66629 10.5002C9.66629 10.7303 9.47974 10.9168 9.24962 10.9168H8.83296C8.1426 10.9168 7.58296 10.3572 7.58296 9.66683V7.5835H7.16629C6.93617 7.5835 6.74962 7.39695 6.74962 7.16683Z" fill="#1E232F"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.28563 3.28612C5.88913 0.682622 10.1102 0.682622 12.7137 3.28612C15.3172 5.88962 15.3172 10.1107 12.7137 12.7142C10.1102 15.3177 5.88913 15.3177 3.28563 12.7142C0.682134 10.1107 0.682134 5.88962 3.28563 3.28612ZM3.87489 3.87537C6.15295 1.59731 9.84641 1.59731 12.1245 3.87537C14.4025 6.15343 14.4025 9.84689 12.1245 12.125C9.84641 14.403 6.15295 14.403 3.87489 12.125C1.59683 9.84689 1.59683 6.15343 3.87489 3.87537Z" fill="#1E232F"/>
                        </svg>
                        <div class="tooltip-txt">
                          {{ $t(option.tooltip) }} 
                        </div>
                      </div>
                      <span class="plan-height-option--title">
                        <template v-for="(plan2, index2) in dataPlan.plans">
                          <div v-if="plan2.show && plan2.groups.length && mobileTab[plan2.name]" :key="index2">
                            <template v-for="(group2, groupIndex2) in plan2.groups">
                              <template
                                v-if="group2.options && group2.options.length && groupIndex == groupIndex2"
                              >
                                <template v-for="(option2, index2) in group2.options">
                                  <template
                                    v-if="index == index2"
                                  >
                                    <template v-if="option2.title">
                                      {{ $t(option2.title) }}
                                    </template>
                                  </template>
                                </template>
                              </template>
                            </template>
                          </div>
                        </template>
                      </span>
                    </div>
                    <div
                      class="plan-group--option last-action"
                      style="justify-content: center"
                      v-if="groupIndex === plan.groups.length - 1">
                      <button
                        class="gt_btn"
                        :disabled="checkPlanStatus(plan.name).disable"
                        :class="{
                          'professional': plan.name === 'professional' && plan.name !== currentPlan,
                        }"
                        @click="changePlan(plan.name)"
                      >
                        <div v-html="checkPlanStatus(plan.name).label" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </div>
    <div class="gp_plans-mobie gp_plans-mobie--bottom">
      <div class="plan-choose-plan">
        <template v-for="(planChoose, indexChoose) in dataPlan.plans">
          <div
            v-if="planChoose.show && planChoose.groups.length"
            class="choose-plan--item"
            :class="{
              'choose-plan--active': mobileTab[planChoose.name], 
            }"
            @click="switchPlanTabMobile(planChoose.name)"
            :key="indexChoose"
          >
            <button
              class="gt_btn"
              :disabled="checkPlanStatus(planChoose.name).disable"
              :class="{
                'professional': planChoose.name === 'professional' && planChoose.name !== currentPlan,
              }"
              @click="changePlan(planChoose.name)"
            >
              <div v-html="checkPlanStatus(planChoose.name).label" />
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TablePricing",
  props: {
    dataPlan: {
      type: Object || Array,
      default: () => [],
    },
    planHighLight: {
      type: String,
    },
    currentPlan: {
      type: String,
    },
    isDevStore: {
      type: Boolean,
    },
    isShowAdvandDiscount: {
      type: Boolean,
    },
    isShowBusinessDiscount: {
      type: Boolean,
    },
    paymentLink: {
      type: Function
    },
    getPriceForPlan: {
      type: Function
    }
  },
  data() {
    return {
      mobileTab: {
        starter: false,
        professional: true,
        advanced: false,
      },
    }
  },
  computed: {
    ...mapState("account", {
      account: (state) => state.shopInfo,
      // plan: state => state.shopInfo.plan
    }),
    isTrial() {
      return this.currentPlan == 'trial'
    },
  },
  methods: {
    changePlan(planName) {
      let url = this.paymentLink(planName)
      window.location.href = url
    },
    changeCollapseStatus(keyword) {
      const el = document.querySelectorAll(`.plan-group--${keyword}`);
      if (el && el.length) {
        el.forEach((e) => {
          e.classList.toggle("plan-group--close");
        });
      }
    },
    checkPlanStatus(planName) {
      if (this.isDevStore) {
        if (this.currentPlan !== "professional" && planName === "professional") {
          return {
            disable: false,
            label: this.$t("pricing.choosePlan"),
          }; 
        } else {
          return {
            disable: true,
            label: planName === "professional" ? this.$t("pricing.currentPlan") : this.$t("pricing.devDisableButtonText"),
          }; 
        }
      }
      if (this.isTrial && this.account.shopifyPlan !== "staff") {
        return {
          disable: false,
          label: this.$t("pricing.choosePlan")
        };
      } else {
        if (this.currentPlan === planName) {
          return {
            disable: true,
            label: this.$t("pricing.currentPlan"),
          };
        } else {
          let label = this.$t("pricing.choosePlan");
          return {
            disable: false,
            label: label,
          };
        }
      }
    },
    switchPlanTabMobile(planName) {
      this.mobileTab = {
        starter: false,
        professional: false,
        advanced: false,
      }
      this.mobileTab[planName] = true 
    }
  },
};
</script>

<style lang="scss" scoped>
.gp_plans-view-more {
  display: flex;
  margin: 0 !important;
  border: 1px solid map-get($light-grey, "300");
  margin-top: 40px;
  
  &.isSticky {
    .plan-item-header {
      box-shadow: 0px 4px 4px rgba(163, 119, 255, 0.2);
      border-bottom: 1px solid map-get($light-grey, "300") !important;
    }
  }
  .plan-item {
    flex: 1 1 auto;
    flex-basis: calc((100% - 31.8989%) / 3);
    position: relative;
    &:first-child {
      flex: 0 1 auto;
      flex-basis: 31.8989%;
      .plan-item-header {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .plan-group--title {
        border-left: 1px solid map-get($light-grey, "300");
      }
      .plan-group--option {
        text-align: left;
      }
    }
    @media screen and (max-width: 1280px) {
      flex-basis: calc((100% - 28.246013%) / 3);
      &:first-child {
        flex-basis: 28.246013%;
      }
    }
    &:last-child {
      .plan-item-header,
      .plan-group--option {
        border-right: none;
      }

      .plan-group--title {
        justify-content: flex-end;
        border-right: 1px solid map-get($light-grey, "300");
        svg {
          display: block;
        }
      }
    }
    &:first-child {
      .plan-group--title {
        svg {
          display: block;
        }
      }
    }
    .plan-item--inner {
      background-color: #ffffff;
      height: 100%;
      .plan-item--recommend {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        background: #7963FF;
        font-size: 12px;
        border: 1px solid #7963FF;
        border-bottom: none;
        color: white;
        position: absolute;
        bottom: 100%;
        width: 100%;
        font-weight: 500;
        left: -1px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        svg {
          margin: 0 4px;
        }
      }
    }
    .plan-item-header {
      background-color: #ffffff;
      padding: 24px;
      text-align: center;
      border-bottom: 1px solid map-get($light-grey, "300");
      border-right: 1px solid map-get($light-grey, "300");
      height: 170px;
      box-sizing: border-box;
      position: sticky;
      top: -80px;
      z-index: 9;
      min-height: 155px;
      box-shadow: 0px 2px 8px rgba(84, 90, 116, 0.12), 0px 2px 4px rgba(84, 90, 116, 0.1);
      @media screen and (max-width: 1279px) {
        top: -95px;
      }
      .currently-trial {
        top: 5px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-color: #FFF1DD;
        color: #FEAC35;
        font-size: 11px;
        padding: 3px 15px;
        box-sizing: border-box;
        width: 80%;
        border: 1px solid #FEAC35;
        border-radius: 5px;
      }
      h2 {
        font-family: "Inter";
        text-transform: uppercase;
        line-height: 30px;
        font-size: 20px;
        margin-top: 0;
        font-weight: 600;
        color: map-get($dark-text-new, "high-contrast");
        margin-bottom: 4px;
      }
      &.header-plan-starter {
        h2 {
          color: map-get($dark-text-new, "high-contrast");
        }
      }
      &.header-plan-professional {
        h2 {
          color: map-get($primary, "200");
        }
      }
      &.header-plan-advanced {
        h2 {
          color: map-get($accent-amber, "300");
        }
      }
      .plan-item--price {
        margin-bottom: 16px;
        color: map-get($dark-text-new, "low-contrast");
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        span {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: map-get($dark-text-new, "low-contrast");

          // &.plan-item--price-compare {
          //   font-size: 24px;
          //   text-decoration: line-through;
          //   margin-right: 4px;
          //   line-height: 1.5;
          //   color: #c0c0c0;
          //   font-weight: 400;
          // }
        }
      }
      .plan-item--price-old {
        margin-left: 4px !important;
        font-weight: 500 !important;
        font-size: 14px !important;
        line-height: 22px !important;
        text-decoration: line-through;
        color: map-get($dark-text-new, "low-contrast") !important;
      }
      @media screen and (max-width: 1280px) {
        padding: 24px 24px 16px 24px;
        height: 155px;
        .plan-item--price{
          margin-bottom: 9px;
        }
      }
    }
    .plan-item-discount {
      position: absolute;
      top: -52px;
      left: 0;
      z-index: 1;
      width: 100%;  
      &--advanced {
        border-radius: 3px 3px 0px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px;
        height: 52px;
        width: calc(100% + 2px);
        margin-left: -1px;
        background-color: map-get($accent-amber, "500");
        border: 1px solid map-get($accent-amber, "300");
        .discount-advanced {
          &--first {
            flex: 1 1 auto;
            background: map-get($accent-amber, "300");
            border-radius: 3px;
            color: map-get($light-grey, "600");
            height: 100%;
            text-align: center;
            margin-right: 6px;
            line-height: 44px;
          }
          &--last {
            text-align: center;
            flex: 1 1 auto;
            color: map-get($dark-text-new, "high-contrast");
          }
        }
      }
      &--professional {
        border-radius: 3px 3px 0px 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px;
        height: 52px;
        width: calc(100% + 2px);
        margin-left: -1px;
        background-color: map-get($primary, "300");
        border: 1px solid map-get($primary, "300");
        .plan-discount__wrapper {
          span {
            font-family: Inter;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
          }
        }
        .discount-professional {
          &--first {
            flex: 1 1 auto;
            background: map-get($accent-amber, "300");
            border-radius: 3px;
            color: map-get($light-grey, "600");
            height: 100%;
            text-align: center;
            margin-right: 6px;
            line-height: 44px;
          }
          &--last {
            text-align: center;
            flex: 1 1 auto;
            color: map-get($dark-text-new, "high-contrast");
          }
        }
      }
    }

    button {
      width: 100%;
      font-family: "Inter";
      min-width: 160px;
      cursor: pointer;
      box-sizing: border-box;
      border-radius: 3px;
      background-color: map-get($light-grey, "600");
      border: 1px solid map-get($light-grey, "200");
      color: map-get($dark-text-new, "high-contrast");
      font-size: 14px;
      padding: 12px 13px;
      height: 48px;
      line-height: 22px;
      text-transform: uppercase;
      margin-top: 0;
      font-weight: 500;
      max-width: 236px;
      &:hover {
        border: 1px solid map-get($dark-text-new, "high-contrast");
      }
      &:active {
        border: 1px solid map-get($primary, "300");
      }
      div {
        min-height: 22px;
      }
      @media screen and (max-width: 1280px) {
        padding: 2px 10px;
        height: 48px;
      }
      .btn-tooltip {
        display: none;
        position: absolute;
        top: calc(100% + 4px + 11px);
        left: 50%;
        transform: translateX(-50%);
        background: #43464B;
        color: white;
        padding: 12px 16px;
        font-size: 16px;
        line-height: 20px;
        width: 215px;
        white-space: normal;
        border-radius: 5px;
        text-transform: none;

        &::before {
          content: '';
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 9px solid transparent;
          border-right: 9px solid transparent;
          border-bottom: 11px solid #43464B;
        }
      }

      &.professional {
        background-color: map-get($primary, "300")!important;
        border: none !important;
        color: map-get($light-grey, "600") !important;
        &:hover {
          background: map-get($primary, "200") !important;
        }
      }
      &:disabled {
        cursor: no-drop;
        background: map-get($light-grey, "300");
        border-radius: 3px;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: map-get($dark-text-new, "disabled");
        &:hover {
          background: map-get($light-grey, "300");
          color: map-get($dark-text-new, "disabled");
          border: 1px solid map-get($light-grey, "300");
          // transform: scale(1.05);
          // transition: all 0.3s;
        }
      }
    }
  }
  .plan-group {
    &:last-child {
      .plan-group--option:last-child {
        border-bottom: none;
      }
    }
    .plan-group--title {
      padding: 0 24px;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      height: 48px;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: map-get($dark-text-new, "high-contrast");
      background-color: map-get($light-text, "low-contrast");
      border-bottom: 1px solid map-get($light-grey, "300");
      border-top: 1px solid map-get($light-grey, "300");
      cursor: pointer;
      &.plan-group--close {
        svg {
          transform: rotateX(180deg);
        }
      }

      .tooltip {
        margin-left: 8px;
        color: #B2AEE9;
      }

      svg {
        display: none;
        cursor: pointer;
      }
    }
    .plan-group--collapse {
      padding-right:30px;
    }

    .plan-group--options {
      &.plan-group--close {
        display: none;
      }
    }

    .plan-group--option {
      width: 100%;
      padding: 13px;
      height: 48px;
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      text-align: center;
      color: map-get($dark-text-new, "high-contrast");

      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid map-get($light-grey, "300");
      border-right: 1px solid map-get($light-grey, "300");
      text-align: center;

      &.option-high-light {
        background-color: #f8f5ff;
        border: 1px solid map-get($light-grey, "300");
        border-bottom: none;
        font-size: 16px;
        color: #4f46ba;
        font-weight: 500;
      }

      svg {
        &.active {
          color: #4f46ba;
        }
      }
      .svg {
        display: inherit;
      }
      .plan-group--option-txt {
        display: flex;
        width: calc(100% - 28px);
        padding-left: 11px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: map-get($dark-text-new, "high-contrast");
        &.no-tootip {
          width: 100%;
        }
        &.disable {
          opacity: 0.5;
        }
      }

      .tag {
        color: #F19620;
        background: #FEF7ED;
        border: 1px solid #F19620;
        border-radius: 5px;
        padding: 1px 8px;
        font-size: 12px;
        margin-left: 5px;
      }

      &.footnote {
        border-right: none;
      }

      &.last-action {
        padding: 24px 12px;
        height: 86px;
      }
    }

    .tooltip {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 4px;
      .tooltip-txt {
        visibility: hidden;
        opacity: 0;
        background-color: map-get($dark-blue, "300" );
        width: 168px;
        text-align: left;
        font-size: 12px;
        color: map-get($light-text, "low-contrast");
        bottom: calc(100% + 10px);
        padding: 4px 8px;
        left: 0;
        transform: translateX(calc(-50% + 8px)) translateY(-10px);
        border-radius: 5px;
        position: absolute;
        z-index: 99;
        transition: all 0.3s;
        &::after {
          content: "";
          position: absolute;
          bottom: -12px;
          left: 50%;
          transform: translateX(-50%);
          border-top: solid 6px map-get($dark-blue, "300" );
          border-right: 6px solid transparent;
          border-left: 6px solid transparent;
          border-bottom: 6px solid transparent;
        }
      }
      &:hover {
        .tooltip-txt {
          visibility: inherit;
          opacity: 1;
          transition: all 0.3s;
          transform: translateX(calc(-50% + 8px)) translateY(0px);
        }
      }
    }
  }
}
.plan-height-option, .plan-height-option--title {
  display: none;
}
::v-deep .br-mobie {
  display: none;
}
.gp_plans-mobie, .plan-tab {
  display: none;
}
@media (max-width: 1024px) {
  $plan-item-left: 69.538461%;
  .gp_plans-view-more {
    position: relative;
    width: calc(100vw - 48px);
    overflow: hidden;
    .plan-item {
      flex-basis: calc((100vw - 48px - 2px) / 100 * (100 -  69.538461));
      flex-shrink: 0;
      .plan-group {
        .plan-group--option {
          >* {
            opacity: 1;
            transition: opacity .5s ease-out;
          }
        }
      }
      &--mobie-tab__hide {
        position: absolute;
        right: 0;
        z-index: -1;
        flex-grow: 0;
        max-width: calc((100vw - 48px - 2px) / 100 * (100 -  69.538461));
        min-width: calc((100vw - 48px - 2px) / 100 * (100 -  69.538461));
        .plan-group {
          .plan-group--option {
            >* {
              opacity: 0;
            }
          }
        }
      }
      &-header {
        display: none;
      }
      .plan-item-discount {
        display: none;
      }
      &:first-child {
        flex-basis: $plan-item-left;
        flex-shrink: 0;
        .plan-group--title {
          border-left: unset;
          border-right: unset !important;
        }
        .plan-item-header {
          display: none;
        }
        .plan-group--option {
          opacity: 1;
          padding: 13px !important;
          border-right: 1px solid map-get($light-grey, "300");
        }
      }
      &:last-child {
        .plan-group--option {
          border-right: 1px solid map-get($light-grey, "300");
        }
        .plan-group--title {
          border-right: unset;
        }
      }
      .plan-group--title {
        border-top: unset;
        border-left: unset;
        border-right: 1px solid map-get($light-grey, "300") !important;
      }
    }
    .plan-group {
      .plan-group--title {
        svg {
          display: block;
        }
      }
      .plan-group--option {
        min-height: 48px;
        max-height: 82px;
        height: auto;
        padding: 8px 12px;
        .plan-group--option-txt {
          width: calc(((100vw - 48px - 2px) / 100 * 69.538461) - 28px);
        }
        &.last-action {
          display: none;
        }
        .svg {
          height: 34px;
          display: flex;
          align-items: center;
        }
      }
      .plan-group--collapse{
        justify-content: end;
        padding-right: 16px;
      }
      .tooltip {
        .tooltip-txt {
          width: 168px;
          &::after {
            left: calc(50% + 48px);
          }
        }
        &:hover {
          .tooltip-txt {
            transform: translateX(calc(-50% + -40px)) translateY(0px);
          }
        }
      }
      &:last-child {
        .plan-group--option {
          &:nth-last-child(2) {
            border-bottom: 0;
          } 
        }
      }
    }
  }
  .plan-height-option {
    display: block;
    height: auto;
    width: 0.001px;
    opacity: 0;
    div {
      width: calc((100vw - 48px - 2px) / 100 * (100 -  69.538461));
      padding: 0 12px;
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      svg {
        display: block;
      }
      span {
        display: block;
        margin: -5px 0;
      }
    }
    &--title {
      display: block;
      height: auto;
      width: 0.001px;
      opacity: 0 !important;
      div {
        width: calc((100vw - 48px - 2px) / 100 *  69.538461);
        padding-left: 11px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        padding: 5px 13px 5px 24px;
      }
    }
  }
  .plan-group--option-box {
    display: flex;
    align-items: center;
  }
  ::v-deep .br-mobie {
    display: block;
  }
  .plan-tab {
    display: flex;
    align-items: center;
    // margin-bottom: 16px;
    padding: 16px 0;
    justify-content: space-around;
    position: -webkit-sticky;
    position: sticky;
    top: -101px;
    background: #fff;
    z-index: 9;
    .plan-tab--item {
      flex: 0 0 calc((100% / 3));
      text-align: center;
      position: relative;
      padding-bottom: 8px;
      cursor: pointer;
      h2 {
        font-family: Inter;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }
      color: map-get($dark-text-new, "high-contrast");
      &.tab-plan-starter {
        color: map-get($dark-text-new, "high-contrast");
      }
      &.tab-plan-professional {
        color: map-get($primary, "300");
      }
      &.tab-plan-advanced {
        color: map-get($accent-amber, "300");
      }
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        height: 2px;
        z-index: 1;
        background: transparent;
        width: 100%;
        left: 0;
      }
      &.tab-plan--active {
        &.tab-plan-starter {
            &::after {
              background: map-get($dark-blue, "100");
            }
        }
        &.tab-plan-professional {
            &::after {
              background: map-get($primary, "300");
            }
        }
        &.tab-plan-advanced {
            &::after {
              background: map-get($accent-amber, "300");
            }
        }
      }
    }
  }
  .gp_plans-mobie {
    display: block;
    // margin-top: 16px;
    &.gp_plans-mobie--top {
      .plan-tab--info {
        display: none;
        &.info-plan--active {
          display: block;
        }
        .info-plan-box {
          background-color: #ffffff;
          padding: 24px;
          text-align: center;
          border-top: 1px solid map-get($light-grey, "300");
          border-left: 1px solid map-get($light-grey, "300");
          border-right: 1px solid map-get($light-grey, "300");
          border-bottom: 0;
          height: 170px;
          box-sizing: border-box;
          border-radius: 3px 3px 0px 0px; 
          min-height: 155px;
          h2 {
            font-family: "Inter";
            text-transform: uppercase;
            line-height: 30px;
            font-size: 20px;
            margin-top: 0;
            font-weight: 600;
            color: map-get($dark-text-new, "high-contrast");
            margin-bottom: 4px;
          }
          &.header-plan-starter {
            h2 {
              color: map-get($dark-text-new, "high-contrast");
            }
          }
          &.header-plan-professional {
            h2 {
              color: map-get($primary, "200");
            }
          }
          &.header-plan-advanced {
            h2 {
              color: map-get($accent-amber, "300");
            }
          }
          .info-plan--price {
            margin-bottom: 16px;
            color: map-get($dark-text-new, "low-contrast");
            font-family: "Inter";
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            span {
              font-weight: 600;
              font-size: 16px;
              line-height: 24px;
              color: map-get($dark-text-new, "low-contrast");
            }
          }
          .info-plan--price-old {
            margin-left: 4px !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            line-height: 22px !important;
            text-decoration: line-through;
            color: map-get($dark-text-new, "low-contrast") !important;
          }
          button {
            width: 100%;
            font-family: "Inter";
            min-width: 160px;
            cursor: pointer;
            box-sizing: border-box;
            border-radius: 3px;
            background-color: map-get($light-grey, "600");
            border: 1px solid map-get($light-grey, "200");
            color: map-get($dark-text-new, "high-contrast");
            font-size: 14px;
            padding: 12px 13px;
            height: 48px;
            line-height: 22px;
            text-transform: uppercase;
            margin-top: 0;
            font-weight: 500;
            max-width: 236px;
            &:hover {
              border: 1px solid map-get($dark-text-new, "high-contrast");
            }
            &:active {
              border: 1px solid map-get($primary, "300");
            }
            div {
              min-height: 22px;
            }
            @media screen and (max-width: 1280px) {
              padding: 2px 10px;
              height: 48px;
            }
  
            &.professional {
              background-color: map-get($primary, "300")!important;
              border: none !important;
              color: map-get($light-grey, "600") !important;
              &:hover {
                background: map-get($primary, "200") !important;
              }
            }
            &:disabled {
              cursor: no-drop;
              background: map-get($light-grey, "300");
              border-radius: 3px;
              font-weight: 500;
              font-size: 14px;
              line-height: 22px;
              color: map-get($dark-text-new, "disabled");
              &:hover {
                background: map-get($light-grey, "300");
                color: map-get($dark-text-new, "disabled");
                border: 1px solid map-get($light-grey, "300");
                // transform: scale(1.05);
                // transition: all 0.3s;
              }
            }
          }
        }
        .plan-item-discount--radius {
            border-radius: 0px 0px 3px 3px;
            border-top: 0;
        }
        .plan-item-discount {
          width: 100%;  
          &--advanced {
            border-radius: 3px 3px 0px 0px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 2px;
            height: 52px;
            width: 100%;
            margin-left: -0;
            background-color: map-get($accent-amber, "500");
            border: 1px solid map-get($accent-amber, "300");
            .discount-advanced {
              &--first {
                flex: 1 1 auto;
                background: map-get($accent-amber, "300");
                border-radius: 3px;
                color: map-get($light-grey, "600");
                height: 100%;
                text-align: center;
                margin-right: 6px;
                line-height: 44px;
              }
              &--last {
                text-align: center;
                flex: 1 1 auto;
                color: map-get($dark-text-new, "high-contrast");
              }
            }
          }
          &--professional {
            border-radius: 3px 3px 0px 0px;
          }
        }
      }
    }
    &.gp_plans-mobie--bottom {
      margin-bottom: 0;
      margin-top: 0;
      .plan-choose-plan {
        background-color: #ffffff;
        padding: 24px;
        text-align: center;
        border-bottom: 1px solid map-get($light-grey, "300");
        border-left: 1px solid map-get($light-grey, "300");
        border-right: 1px solid map-get($light-grey, "300");
        border-top: 0;
        height: auto;
        box-sizing: border-box;
        border-radius: 0px 0px 3px 3px ; 
        .choose-plan--item {
          display: none;
        }
        .choose-plan--active {
          display: block;
        }
        button {
          width: 100%;
          font-family: "Inter";
          min-width: 160px;
          cursor: pointer;
          box-sizing: border-box;
          border-radius: 3px;
          background-color: map-get($light-grey, "600");
          border: 1px solid map-get($light-grey, "200");
          color: map-get($dark-text-new, "high-contrast");
          font-size: 14px;
          padding: 12px 13px;
          height: 48px;
          line-height: 22px;
          text-transform: uppercase;
          margin-top: 0;
          font-weight: 500;
          &:hover {
            border: 1px solid map-get($dark-text-new, "high-contrast");
          }
          &:active {
            border: 1px solid map-get($primary, "300");
          }
          div {
            min-height: 22px;
          }
          @media screen and (max-width: 1280px) {
            padding: 2px 10px;
            height: 48px;
          }
  
          &.professional {
            background-color: map-get($primary, "300")!important;
            border: none !important;
            color: map-get($light-grey, "600") !important;
            &:hover {
              background: map-get($primary, "200") !important;
            }
          }
          &:disabled {
            cursor: no-drop;
            background: map-get($light-grey, "300");
            border-radius: 3px;
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            color: map-get($dark-text-new, "disabled");
            &:hover {
              background: map-get($light-grey, "300");
              color: map-get($dark-text-new, "disabled");
              border: 1px solid map-get($light-grey, "300");
            }
          }
        }
      }
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 1024px) {
  $plan-item-left: 69.538461%;
  .gp_plans-view-more {
    width: 100%;
    overflow: hidden;
    .plan-item {
      flex-basis: calc((576px - 48px - 2px) / 100 * (100 -  69.538461));
      &--mobie-tab__hide {
        max-width: calc((576px - 48px - 2px) / 100 * (100 -  69.538461));
        min-width: calc((576px - 48px - 2px) / 100 * (100 -  69.538461));
      }
      &:first-child {
        flex-basis: $plan-item-left;
      }
    }
    .plan-group {
      .plan-group--option {
        .plan-group--option-txt {
          width: calc(((576px - 48px - 2px) / 100 * 69.538461) - 28px);
        }
      }
    }
  }
  .plan-height-option {
    div {
      // 69.538461 = $plan-item-left:
      width: calc((576px - 48px - 2px) / 100 * (100 -  69.538461));
    }
    &--title {
      div {
        width: calc((576px - 48px - 2px) / 100 *  69.538461);
      }
    }
  }
  .gp_plans-mobie {
    &.gp_plans-mobie--top {
      .plan-tab {
        .plan-tab--item {
          &.tab-plan-starter {
            &::after {
              width: calc(100%);
            }
          }
          &.tab-plan-professional {
            &::after {
              width: 100%;
            }
          }
          &.tab-plan-advanced {
            &::after {
              width: calc(100%);
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  $plan-item-left: 69.538461%;
  .gp_plans-view-more {
    .plan-item {
      flex-basis: calc((768px - 48px - 2px) / 100 * (100 -  69.538461));
      &--mobie-tab__hide {
        max-width: calc((768px - 48px - 2px) / 100 * (100 -  69.538461));
        min-width: calc((768px - 48px - 2px) / 100 * (100 -  69.538461));
      }
      &:first-child {
        flex-basis: $plan-item-left;
      }
    }
    .plan-group {
      .plan-group--option {
        .plan-group--option-txt {
          width: calc(((768px - 48px - 2px) / 100 * 69.538461) - 28px);
        }
      }
    }
  }
  .plan-height-option {
    div {
      // 69.538461 = $plan-item-left:
      width: calc((768px - 48px - 2px) / 100 * (100 -  69.538461));
    }
    &--title {
      div {
        width: calc((768px - 48px - 2px) / 100 *  69.538461);
      }
    }
  }
  .gp_plans-mobie {
    &.gp_plans-mobie--top {
      .plan-tab {
        .plan-tab--item {
          &.tab-plan-starter {
            &::after {
              width: calc(100%);
            }
          }
          &.tab-plan-professional {
            &::after {
              width: 100%;
            }
          }
          &.tab-plan-advanced {
            &::after {
              width: calc(100%);
            }
          }
        }
      }
    }
  }
}
</style>
